import { xml2json } from "xml-js";
import moment from "moment-timezone";

/**
 *  TOOLS
 */

function getDate(json) {
    return moment(
        json["rsm:CrossIndustryInvoice"]["rsm:ExchangedDocument"]["ram:IssueDateTime"][
            "udt:DateTimeString"
        ]["_text"],
        "YYYYMMDD",
    ).toISOString();
}

function getTotalAmounts(json) {
    const ht =
        json["rsm:CrossIndustryInvoice"]["rsm:SupplyChainTradeTransaction"][
            "ram:ApplicableHeaderTradeSettlement"
        ]["ram:SpecifiedTradeSettlementHeaderMonetarySummation"]["ram:TaxBasisTotalAmount"][
            "_text"
        ];
    const ttc =
        json["rsm:CrossIndustryInvoice"]["rsm:SupplyChainTradeTransaction"][
            "ram:ApplicableHeaderTradeSettlement"
        ]["ram:SpecifiedTradeSettlementHeaderMonetarySummation"]["ram:GrandTotalAmount"]["_text"];
    const tva =
        json["rsm:CrossIndustryInvoice"]["rsm:SupplyChainTradeTransaction"][
            "ram:ApplicableHeaderTradeSettlement"
        ]["ram:SpecifiedTradeSettlementHeaderMonetarySummation"]["ram:TaxTotalAmount"]["_text"];

    return {
        grossAmount: parseFloat(ht),
        netAmount: parseFloat(ttc),
        vatAmount: parseFloat(tva),
    };
}

function getName(json) {
    return json["rsm:CrossIndustryInvoice"]["rsm:SupplyChainTradeTransaction"][
        "ram:ApplicableHeaderTradeAgreement"
    ]["ram:BuyerOrderReferencedDocument"]["ram:IssuerAssignedID"]["_text"];
}

function formatCompany(company) {
    let siret = null;
    if (
        company["ram:SpecifiedLegalOrganization"] &&
        company["ram:SpecifiedLegalOrganization"]["ram:ID"]["_attributes"]["schemeID"] &&
        company["ram:SpecifiedLegalOrganization"]["ram:ID"]["_attributes"]["schemeID"] === "0002"
    ) {
        siret = company["ram:SpecifiedLegalOrganization"]["ram:ID"]["_text"];
    }
    return {
        name: company["ram:Name"]["_text"],
        siret: siret ? siret : "84109722300017",
    };
}

function getSellerComany(json) {
    const company = formatCompany(
        json["rsm:CrossIndustryInvoice"]["rsm:SupplyChainTradeTransaction"][
            "ram:ApplicableHeaderTradeAgreement"
        ]["ram:SellerTradeParty"],
    );
    return company;
}

function getBuyerCompany(json) {
    return formatCompany(
        json["rsm:CrossIndustryInvoice"]["rsm:SupplyChainTradeTransaction"][
            "ram:ApplicableHeaderTradeAgreement"
        ]["ram:BuyerTradeParty"],
    );
}

function getType(json, company) {
    //? ERIC: Est ce que par default, si c'est pas une facture de vente je dis que c'est une facture d'achat ?
    const seller = getSellerComany(json);
    if (seller.siret && seller.siret === company.siret) {
        return "SALES_INVOICE";
    }
    const buyer = getBuyerCompany(json);
    if (
        buyer.name.toLowerCase() === company.name.toLowerCase() ||
        buyer.name.toLowerCase() === company.name.toLowerCase()
    ) {
        return "PURCHASE_INVOICE";
    }
    return "SALES_INVOICE";
}

function getVats(json) {
    const data =
        json["rsm:CrossIndustryInvoice"]["rsm:SupplyChainTradeTransaction"][
            "ram:ApplicableHeaderTradeSettlement"
        ]["ram:ApplicableTradeTax"];
    if (data) {
        const vats = data.map((line, index) => ({
            vatAmount: parseFloat(line["ram:CalculatedAmount"]["_text"]),
            vatRate: parseFloat(line["ram:RateApplicablePercent"]["_text"]),
            grossAmount: parseFloat(line["ram:BasisAmount"]["_text"]),
            category: getVATType(line["ram:CategoryCode"]["_text"]),
        }));
        debugger;
        return vats;
    }
    return null;

    /**
     *  S = Taux de TVA standard
        Z = Taux de TVA égal à 0 (non applicable en France)
        E = Exempté de TVA
        AE = Autoliquidation de TVA
        K = Autoliquidation pour cause de livraison intracommunautaire
        G = Exempté de TVA pour Export hors UE
        O = Hors du périmètre d'application de la TVA
        L = Iles Canaries
        M = Ceuta et Mellila


        NO_VAT_TYPE
        INTRACOM
        IMPORT
        EXPORT
        REVERSE_CHARGE
    */
}

function getVATType(code) {
    switch (code) {
        case "S":
            return null;
        case "Z":
            return null;
        case "E":
            return null;
        case "AE":
            return "REVERSE_CHARGE";
        case "K":
            return "INTRACOM"; // not vat accountable account (subAmount)
        case "G":
            return "EXPORT";
        case "O":
            return null;
        case "L":
            return null;
        case "M":
            return null;
    }
}

/**
 * EXPORT FUNCTIONS
 */

export async function getFacturXData(file, company) {
    const reader = new FileReader();
    reader.onload = async () => {
        if (reader.result) {
            debugger;
            const content = reader.result.toString();
            let xml = content.substring(content.indexOf("<?xml version='1.0' encoding='UTF-8'?>"));
            xml = xml.split("endstream")[0];
            getDocument(xml, company);
        }
    };
    await reader.readAsText(file.file);
    debugger;
}

export function getDocument(xml, company) {
    const json = JSON.parse(xml2json(xml, { compact: true, spaces: 4 }));
    const type = facturXType(json);
    switch (type) {
        case "MINIMUM": {
            return formatMinimalDocument(json, company);
        }
        case "BASIC_WL": {
            return formatBasicWLDocument(json, company);
        }
        case "BASIC": {
            return formatBasicDocument(json, company);
        }
        case "EXTENDED": {
            return formatExtendedDocument(json, company);
        }
        case "EN_16931": {
            return formatEN16931Document(json, company);
        }
    }
}

export function facturXType(json) {
    const type =
        json["rsm:CrossIndustryInvoice"]["rsm:ExchangedDocumentContext"][
            "ram:GuidelineSpecifiedDocumentContextParameter"
        ]["ram:ID"]["_text"];
    if (type.includes("minimum")) {
        return "MINIMUM";
    } else if (type.includes("basicwl")) {
        return "BASIC_WL";
    } else if (type.includes("basic")) {
        return "BASIC";
    } else if (type.includes("extended")) {
        return "EXTENDED";
    } else if (type.includes("en16931")) {
        return "EN_16931";
    }
}

function getBaseDocument(json, company) {
    const amounts = getTotalAmounts(json);
    const date = getDate(json);
    const name = getName(json);
    const type = getType(json, company);
    // const seller = type === "SALES_INVOICE" ? getSellerComany(json) : type === "PURCHASE_INVOICE" ? getBuyerCompany(json) : undefined
    // const buyer = type === "PURCHASE_INVOICE" ? getBuyerCompany(json) : type === "SALES_INVOICE" ? getSellerComany(json) : undefined
    return {
        ...amounts,
        date,
        name,
        type,
        // seller,
        // buyer
    };
}

export function formatMinimalDocument(json, company) {
    return getBaseDocument(json, company);
}

export function formatBasicDocument(json, company) {
    return getBaseDocument(json, company);
}

export function formatBasicWLDocument(json, company) {
    return getBaseDocument(json, company);
}

export function formatExtendedDocument(json, company) {
    // getVats(json)
    const document = {
        ...getBaseDocument(json, company),
        multiVat: !!getVats(json),
    };
    if (document.multiVat) {
        document["data"]["subAmounts"] = getVats(json);
    }
    return document;
}

export function formatEN16931Document(json, company) {
    return getBaseDocument(json, company);
}

/**
 * {
    "_attributes": {
        "xmlns:qdt": "urn:un:unece:uncefact:data:standard:QualifiedDataType:100",
        "xmlns:ram": "urn:un:unece:uncefact:data:standard:ReusableAggregateBusinessInformationEntity:100",
        "xmlns:rsm": "urn:un:unece:uncefact:data:standard:CrossIndustryInvoice:100",
        "xmlns:udt": "urn:un:unece:uncefact:data:standard:UnqualifiedDataType:100",
        "xmlns:xsi": "http://www.w3.org/2001/XMLSchema-instance"
    },
    "rsm:ExchangedDocumentContext": {
        "ram:BusinessProcessSpecifiedDocumentContextParameter": {
            "ram:ID": {
                "_text": "A1"
            }
        },
        "ram:GuidelineSpecifiedDocumentContextParameter": {
            "ram:ID": {
                "_text": "urn:factur-x.eu:1p0:minimum"
            }
        }
    },
    "rsm:ExchangedDocument": {
        "ram:ID": {
            "_text": "F20200023"
        },
        "ram:TypeCode": {
            "_text": "380"
        },
        "ram:IssueDateTime": {
            "udt:DateTimeString": {
                "_attributes": {
                    "format": "102"
                },
                "_text": "20200115"
            }
        }
    },
    "rsm:SupplyChainTradeTransaction": {
        "ram:ApplicableHeaderTradeAgreement": {
            "ram:BuyerReference": {
                "_text": "SERVEXEC"
            },
            "ram:SellerTradeParty": {
                "ram:Name": {
                    "_text": "LE FOURNISSEUR"
                },
                "ram:SpecifiedLegalOrganization": {
                    "ram:ID": {
                        "_attributes": {
                            "schemeID": "0002"
                        },
                        "_text": "12345678900014"
                    }
                },
                "ram:PostalTradeAddress": {
                    "ram:CountryID": {
                        "_text": "FR"
                    }
                },
                "ram:SpecifiedTaxRegistration": {
                    "ram:ID": {
                        "_attributes": {
                            "schemeID": "VA"
                        },
                        "_text": "FR32123456789"
                    }
                }
            },
            "ram:BuyerTradeParty": {
                "ram:Name": {
                    "_text": "LE CLIENT"
                },
                "ram:SpecifiedLegalOrganization": {
                    "ram:ID": {
                        "_attributes": {
                            "schemeID": "0002"
                        },
                        "_text": "98765432100029"
                    }
                }
            },
            "ram:BuyerOrderReferencedDocument": {
                "ram:IssuerAssignedID": {
                    "_text": "PO201925478"
                }
            }
        },
        "ram:ApplicableHeaderTradeDelivery": {},
        "ram:ApplicableHeaderTradeSettlement": {
            "ram:InvoiceCurrencyCode": {
                "_text": "EUR"
            },
            "ram:SpecifiedTradeSettlementHeaderMonetarySummation": {
                "ram:TaxBasisTotalAmount": {
                    "_text": "100.00"
                },
                "ram:TaxTotalAmount": {
                    "_attributes": {
                        "currencyID": "EUR"
                    },
                    "_text": "4.90"
                },
                "ram:GrandTotalAmount": {
                    "_text": "104.90"
                },
                "ram:DuePayableAmount": {
                    "_text": "104.90"
                }
            }
        }
    }
}

















{
    "_attributes": {
        "xmlns:qdt": "urn:un:unece:uncefact:data:standard:QualifiedDataType:100",
        "xmlns:ram": "urn:un:unece:uncefact:data:standard:ReusableAggregateBusinessInformationEntity:100",
        "xmlns:rsm": "urn:un:unece:uncefact:data:standard:CrossIndustryInvoice:100",
        "xmlns:udt": "urn:un:unece:uncefact:data:standard:UnqualifiedDataType:100",
        "xmlns:xsi": "http://www.w3.org/2001/XMLSchema-instance"
    },
    "rsm:ExchangedDocumentContext": {
        "ram:BusinessProcessSpecifiedDocumentContextParameter": {
            "ram:ID": {
                "_text": "A1"
            }
        },
        "ram:GuidelineSpecifiedDocumentContextParameter": {
            "ram:ID": {
                "_text": "urn:cen.eu:en16931:2017#conformant#urn:factur-x.eu:1p0:extended"
            }
        }
    },
    "rsm:ExchangedDocument": {
        "ram:ID": {
            "_text": "F20200023"
        },
        "ram:TypeCode": {
            "_text": "380"
        },
        "ram:IssueDateTime": {
            "udt:DateTimeString": {
                "_attributes": {
                    "format": "102"
                },
                "_text": "20200115"
            }
        },
        "ram:IncludedNote": [
            {
                "ram:Content": {
                    "_text": "FOURNISSEUR F SARL au capital de 50 000 EUR"
                },
                "ram:SubjectCode": {
                    "_text": "REG"
                }
            },
            {
                "ram:Content": {
                    "_text": "RCS MAVILLE 123 456 789"
                },
                "ram:SubjectCode": {
                    "_text": "ABL"
                }
            },
            {
                "ram:Content": {
                    "_text": "Tout retard de paiement engendre une pénalité exigible à compter de la date d'échéance, calculée sur la base de trois fois le taux d'intérêt légal. Indemnité forfaitaire pour frais de recouvrement en cas de retard de paiement : 40 €."
                },
                "ram:SubjectCode": {
                    "_text": "PMT"
                }
            },
            {
                "ram:Content": {
                    "_text": "RCS MAVILLE 123 456 789"
                },
                "ram:SubjectCode": {
                    "_text": "ABL"
                }
            }
        ]
    },
    "rsm:SupplyChainTradeTransaction": {
        "ram:IncludedSupplyChainTradeLineItem": [
            {
                "ram:AssociatedDocumentLineDocument": {
                    "ram:LineID": {
                        "_text": "1"
                    }
                },
                "ram:SpecifiedTradeProduct": {
                    "ram:GlobalID": {
                        "_attributes": {
                            "schemeID": "0088"
                        },
                        "_text": "598785412598745"
                    },
                    "ram:Name": {
                        "_text": "PRESTATION SUPPORT"
                    },
                    "ram:Description": {
                        "_text": "Description"
                    }
                },
                "ram:SpecifiedLineTradeAgreement": {
                    "ram:BuyerOrderReferencedDocument": {
                        "ram:LineID": {
                            "_text": "1"
                        }
                    },
                    "ram:NetPriceProductTradePrice": {
                        "ram:ChargeAmount": {
                            "_text": "60.0000"
                        },
                        "ram:BasisQuantity": {
                            "_attributes": {
                                "unitCode": "C62"
                            },
                            "_text": "1.0000"
                        }
                    }
                },
                "ram:SpecifiedLineTradeDelivery": {
                    "ram:BilledQuantity": {
                        "_attributes": {
                            "unitCode": "C62"
                        },
                        "_text": "1.0000"
                    }
                },
                "ram:SpecifiedLineTradeSettlement": {
                    "ram:ApplicableTradeTax": {
                        "ram:TypeCode": {
                            "_text": "VAT"
                        },
                        "ram:CategoryCode": {
                            "_text": "E"
                        },
                        "ram:RateApplicablePercent": {
                            "_text": "0.00"
                        }
                    },
                    "ram:BillingSpecifiedPeriod": {
                        "ram:StartDateTime": {
                            "udt:DateTimeString": {
                                "_attributes": {
                                    "format": "102"
                                },
                                "_text": "20191201"
                            }
                        },
                        "ram:EndDateTime": {
                            "udt:DateTimeString": {
                                "_attributes": {
                                    "format": "102"
                                },
                                "_text": "20191231"
                            }
                        }
                    },
                    "ram:SpecifiedTradeAllowanceCharge": [
                        {
                            "ram:ChargeIndicator": {
                                "udt:Indicator": {
                                    "_text": "false"
                                }
                            },
                            "ram:CalculationPercent": {
                                "_text": "1.00"
                            },
                            "ram:BasisAmount": {
                                "_text": "100.00"
                            },
                            "ram:ActualAmount": {
                                "_text": "1.00"
                            },
                            "ram:ReasonCode": {
                                "_text": "71"
                            },
                            "ram:Reason": {
                                "_text": "REMISE VOLUME"
                            }
                        },
                        {
                            "ram:ChargeIndicator": {
                                "udt:Indicator": {
                                    "_text": "false"
                                }
                            },
                            "ram:ActualAmount": {
                                "_text": "1.00"
                            },
                            "ram:ReasonCode": {
                                "_text": "71"
                            },
                            "ram:Reason": {
                                "_text": "REMISE VOLUME"
                            }
                        },
                        {
                            "ram:ChargeIndicator": {
                                "udt:Indicator": {
                                    "_text": "false"
                                }
                            },
                            "ram:ActualAmount": {
                                "_text": "1.00"
                            },
                            "ram:ReasonCode": {
                                "_text": "71"
                            },
                            "ram:Reason": {
                                "_text": "REMISE VOLUME"
                            }
                        },
                        {
                            "ram:ChargeIndicator": {
                                "udt:Indicator": {
                                    "_text": "false"
                                }
                            },
                            "ram:ActualAmount": {
                                "_text": "1.00"
                            },
                            "ram:ReasonCode": {
                                "_text": "100"
                            }
                        },
                        {
                            "ram:ChargeIndicator": {
                                "udt:Indicator": {
                                    "_text": "true"
                                }
                            },
                            "ram:ActualAmount": {
                                "_text": "1.00"
                            },
                            "ram:Reason": {
                                "_text": "FRAIS PALETTE"
                            }
                        },
                        {
                            "ram:ChargeIndicator": {
                                "udt:Indicator": {
                                    "_text": "true"
                                }
                            },
                            "ram:ActualAmount": {
                                "_text": "1.00"
                            },
                            "ram:Reason": {
                                "_text": "FRAIS PALETTE"
                            }
                        },
                        {
                            "ram:ChargeIndicator": {
                                "udt:Indicator": {
                                    "_text": "true"
                                }
                            },
                            "ram:ActualAmount": {
                                "_text": "1.00"
                            },
                            "ram:Reason": {
                                "_text": "FRAIS PALETTE"
                            }
                        },
                        {
                            "ram:ChargeIndicator": {
                                "udt:Indicator": {
                                    "_text": "true"
                                }
                            },
                            "ram:ActualAmount": {
                                "_text": "1.00"
                            },
                            "ram:Reason": {
                                "_text": "FRAIS PALETTE"
                            }
                        }
                    ],
                    "ram:SpecifiedTradeSettlementLineMonetarySummation": {
                        "ram:LineTotalAmount": {
                            "_text": "60.00"
                        }
                    }
                }
            },
            {
                "ram:AssociatedDocumentLineDocument": {
                    "ram:LineID": {
                        "_text": "2"
                    }
                },
                "ram:SpecifiedTradeProduct": {
                    "ram:Name": {
                        "_text": "FOURNITURES DIVERSES"
                    },
                    "ram:Description": {
                        "_text": "Description"
                    }
                },
                "ram:SpecifiedLineTradeAgreement": {
                    "ram:BuyerOrderReferencedDocument": {
                        "ram:LineID": {
                            "_text": "3"
                        }
                    },
                    "ram:NetPriceProductTradePrice": {
                        "ram:ChargeAmount": {
                            "_text": "30.0000"
                        },
                        "ram:BasisQuantity": {
                            "_attributes": {
                                "unitCode": "C62"
                            },
                            "_text": "3.0000"
                        }
                    }
                },
                "ram:SpecifiedLineTradeDelivery": {
                    "ram:BilledQuantity": {
                        "_attributes": {
                            "unitCode": "C62"
                        },
                        "_text": "3.0000"
                    }
                },
                "ram:SpecifiedLineTradeSettlement": {
                    "ram:ApplicableTradeTax": {
                        "ram:TypeCode": {
                            "_text": "VAT"
                        },
                        "ram:CategoryCode": {
                            "_text": "S"
                        },
                        "ram:RateApplicablePercent": {
                            "_text": "10.00"
                        }
                    },
                    "ram:BillingSpecifiedPeriod": {
                        "ram:StartDateTime": {
                            "udt:DateTimeString": {
                                "_attributes": {
                                    "format": "102"
                                },
                                "_text": "20191231"
                            }
                        },
                        "ram:EndDateTime": {
                            "udt:DateTimeString": {
                                "_attributes": {
                                    "format": "102"
                                },
                                "_text": "20191231"
                            }
                        }
                    },
                    "ram:SpecifiedTradeAllowanceCharge": [
                        {
                            "ram:ChargeIndicator": {
                                "udt:Indicator": {
                                    "_text": "false"
                                }
                            },
                            "ram:ActualAmount": {
                                "_text": "2.00"
                            },
                            "ram:ReasonCode": {
                                "_text": "71"
                            },
                            "ram:Reason": {
                                "_text": "REMISE VOLUME"
                            }
                        },
                        {
                            "ram:ChargeIndicator": {
                                "udt:Indicator": {
                                    "_text": "false"
                                }
                            },
                            "ram:ActualAmount": {
                                "_text": "1.00"
                            },
                            "ram:ReasonCode": {
                                "_text": "71"
                            },
                            "ram:Reason": {
                                "_text": "REMISE VOLUME"
                            }
                        },
                        {
                            "ram:ChargeIndicator": {
                                "udt:Indicator": {
                                    "_text": "false"
                                }
                            },
                            "ram:ActualAmount": {
                                "_text": "1.00"
                            },
                            "ram:ReasonCode": {
                                "_text": "71"
                            },
                            "ram:Reason": {
                                "_text": "REMISE VOLUME"
                            }
                        },
                        {
                            "ram:ChargeIndicator": {
                                "udt:Indicator": {
                                    "_text": "false"
                                }
                            },
                            "ram:ActualAmount": {
                                "_text": "1.00"
                            },
                            "ram:ReasonCode": {
                                "_text": "100"
                            }
                        },
                        {
                            "ram:ChargeIndicator": {
                                "udt:Indicator": {
                                    "_text": "true"
                                }
                            },
                            "ram:ActualAmount": {
                                "_text": "1.00"
                            },
                            "ram:ReasonCode": {
                                "_text": "ADL"
                            }
                        },
                        {
                            "ram:ChargeIndicator": {
                                "udt:Indicator": {
                                    "_text": "true"
                                }
                            },
                            "ram:ActualAmount": {
                                "_text": "1.00"
                            },
                            "ram:Reason": {
                                "_text": "FRAIS PALETTE"
                            }
                        },
                        {
                            "ram:ChargeIndicator": {
                                "udt:Indicator": {
                                    "_text": "true"
                                }
                            },
                            "ram:ActualAmount": {
                                "_text": "1.00"
                            },
                            "ram:Reason": {
                                "_text": "FRAIS PALETTE"
                            }
                        }
                    ],
                    "ram:SpecifiedTradeSettlementLineMonetarySummation": {
                        "ram:LineTotalAmount": {
                            "_text": "28.00"
                        }
                    }
                }
            },
            {
                "ram:AssociatedDocumentLineDocument": {
                    "ram:LineID": {
                        "_text": "3"
                    }
                },
                "ram:SpecifiedTradeProduct": {
                    "ram:Name": {
                        "_text": "APPEL"
                    },
                    "ram:Description": {
                        "_text": "Description"
                    }
                },
                "ram:SpecifiedLineTradeAgreement": {
                    "ram:BuyerOrderReferencedDocument": {
                        "ram:LineID": {
                            "_text": "2"
                        }
                    },
                    "ram:NetPriceProductTradePrice": {
                        "ram:ChargeAmount": {
                            "_text": "7.0000"
                        }
                    }
                },
                "ram:SpecifiedLineTradeDelivery": {
                    "ram:BilledQuantity": {
                        "_attributes": {
                            "unitCode": "C62"
                        },
                        "_text": "1.0000"
                    }
                },
                "ram:SpecifiedLineTradeSettlement": {
                    "ram:ApplicableTradeTax": {
                        "ram:TypeCode": {
                            "_text": "VAT"
                        },
                        "ram:CategoryCode": {
                            "_text": "S"
                        },
                        "ram:RateApplicablePercent": {
                            "_text": "20.00"
                        }
                    },
                    "ram:SpecifiedTradeSettlementLineMonetarySummation": {
                        "ram:LineTotalAmount": {
                            "_text": "7.00"
                        }
                    }
                }
            }
        ],
        "ram:ApplicableHeaderTradeAgreement": {
            "ram:BuyerReference": {
                "_text": "SERVEXEC"
            },
            "ram:SellerTradeParty": {
                "ram:ID": {
                    "_text": "123"
                },
                "ram:GlobalID": [
                    {
                        "_attributes": {
                            "schemeID": "0088"
                        },
                        "_text": "587451236587"
                    },
                    {
                        "_attributes": {
                            "schemeID": "0088"
                        },
                        "_text": "587451236587"
                    },
                    {
                        "_attributes": {
                            "schemeID": "0088"
                        },
                        "_text": "587451236587"
                    },
                    {
                        "_attributes": {
                            "schemeID": "0088"
                        },
                        "_text": "587451236587"
                    }
                ],
                "ram:Name": {
                    "_text": "LE FOURNISSEUR"
                },
                "ram:SpecifiedLegalOrganization": {
                    "ram:ID": {
                        "_attributes": {
                            "schemeID": "0002"
                        },
                        "_text": "12345678900014"
                    },
                    "ram:TradingBusinessName": {
                        "_text": "SELLER TRADE NAME"
                    }
                },
                "ram:DefinedTradeContact": {
                    "ram:PersonName": {
                        "_text": "M. CONTACT"
                    },
                    "ram:DepartmentName": {
                        "_text": "DEP SELLER"
                    },
                    "ram:TelephoneUniversalCommunication": {
                        "ram:CompleteNumber": {
                            "_text": "01 02 03 54 87"
                        }
                    },
                    "ram:EmailURIUniversalCommunication": {
                        "ram:URIID": {
                            "_text": "seller@seller.com"
                        }
                    }
                },
                "ram:PostalTradeAddress": {
                    "ram:PostcodeCode": {
                        "_text": "75018"
                    },
                    "ram:LineOne": {
                        "_text": "35 rue d'ici"
                    },
                    "ram:LineTwo": {
                        "_text": "Seller line 2"
                    },
                    "ram:LineThree": {
                        "_text": "Seller line 3"
                    },
                    "ram:CityName": {
                        "_text": "PARIS"
                    },
                    "ram:CountryID": {
                        "_text": "FR"
                    }
                },
                "ram:URIUniversalCommunication": {
                    "ram:URIID": {
                        "_attributes": {
                            "schemeID": "EM"
                        },
                        "_text": "moi@seller.com"
                    }
                },
                "ram:SpecifiedTaxRegistration": {
                    "ram:ID": {
                        "_attributes": {
                            "schemeID": "VA"
                        },
                        "_text": "FR32123456789"
                    }
                }
            },
            "ram:BuyerTradeParty": {
                "ram:GlobalID": [
                    {
                        "_attributes": {
                            "schemeID": "0088"
                        },
                        "_text": "3654789851"
                    },
                    {
                        "_attributes": {
                            "schemeID": "0088"
                        },
                        "_text": "3654789851"
                    },
                    {
                        "_attributes": {
                            "schemeID": "0088"
                        },
                        "_text": "3654789851"
                    },
                    {
                        "_attributes": {
                            "schemeID": "0088"
                        },
                        "_text": "3654789851"
                    }
                ],
                "ram:Name": {
                    "_text": "LE CLIENT"
                },
                "ram:SpecifiedLegalOrganization": {
                    "ram:ID": {
                        "_attributes": {
                            "schemeID": "0002"
                        },
                        "_text": "98765432100029"
                    }
                },
                "ram:DefinedTradeContact": {
                    "ram:PersonName": {
                        "_text": "Buyer contact name"
                    },
                    "ram:DepartmentName": {
                        "_text": "Buyer dep"
                    },
                    "ram:TelephoneUniversalCommunication": {
                        "ram:CompleteNumber": {
                            "_text": "01 01 25 45 87"
                        }
                    },
                    "ram:EmailURIUniversalCommunication": {
                        "ram:URIID": {
                            "_text": "buyer@buyer.com"
                        }
                    }
                },
                "ram:PostalTradeAddress": {
                    "ram:PostcodeCode": {
                        "_text": "06000"
                    },
                    "ram:LineOne": {
                        "_text": "MON ADRESSE LIGNE 1"
                    },
                    "ram:LineTwo": {
                        "_text": "Buyer line 2"
                    },
                    "ram:LineThree": {
                        "_text": "Buyer line 3"
                    },
                    "ram:CityName": {
                        "_text": "MA VILLE"
                    },
                    "ram:CountryID": {
                        "_text": "FR"
                    }
                },
                "ram:URIUniversalCommunication": {
                    "ram:URIID": {
                        "_attributes": {
                            "schemeID": "EM"
                        },
                        "_text": "me@buyer.com"
                    }
                },
                "ram:SpecifiedTaxRegistration": {
                    "ram:ID": {
                        "_attributes": {
                            "schemeID": "VA"
                        },
                        "_text": "FR 05 987 654 321"
                    }
                }
            },
            "ram:SellerTaxRepresentativeTradeParty": {
                "ram:Name": {
                    "_text": "SELLER TAX REP"
                },
                "ram:PostalTradeAddress": {
                    "ram:PostcodeCode": {
                        "_text": "75018"
                    },
                    "ram:LineOne": {
                        "_text": "35 rue d'ici"
                    },
                    "ram:LineTwo": {
                        "_text": "Seller line 2"
                    },
                    "ram:LineThree": {
                        "_text": "Seller line 3"
                    },
                    "ram:CityName": {
                        "_text": "PARIS"
                    },
                    "ram:CountryID": {
                        "_text": "FR"
                    }
                },
                "ram:SpecifiedTaxRegistration": {
                    "ram:ID": {
                        "_attributes": {
                            "schemeID": "VA"
                        },
                        "_text": "FR 05 987 654 321"
                    }
                }
            },
            "ram:SellerOrderReferencedDocument": {
                "ram:IssuerAssignedID": {
                    "_text": "SALES REF 2547"
                }
            },
            "ram:BuyerOrderReferencedDocument": {
                "ram:IssuerAssignedID": {
                    "_text": "PO201925478"
                }
            },
            "ram:ContractReferencedDocument": {
                "ram:IssuerAssignedID": {
                    "_text": "CT2018120802"
                }
            },
            "ram:AdditionalReferencedDocument": [
                {
                    "ram:IssuerAssignedID": {
                        "_text": "SUPPort doc"
                    },
                    "ram:URIID": {
                        "_text": "url:gffter"
                    },
                    "ram:TypeCode": {
                        "_text": "916"
                    },
                    "ram:Name": {
                        "_text": "support descript"
                    }
                },
                {
                    "ram:IssuerAssignedID": {
                        "_text": "TENDER-002"
                    },
                    "ram:TypeCode": {
                        "_text": "50"
                    }
                },
                {
                    "ram:IssuerAssignedID": {
                        "_text": "REFCLI0215"
                    },
                    "ram:TypeCode": {
                        "_text": "130"
                    },
                    "ram:ReferenceTypeCode": {
                        "_text": "IT"
                    }
                }
            ],
            "ram:SpecifiedProcuringProject": {
                "ram:ID": {
                    "_text": "PROJET2547"
                },
                "ram:Name": {
                    "_text": "Project reference"
                }
            }
        },
        "ram:ApplicableHeaderTradeDelivery": {
            "ram:ShipToTradeParty": {
                "ram:ID": {
                    "_text": "PRIVATE_ID_DEL"
                },
                "ram:Name": {
                    "_text": "DEL Name"
                },
                "ram:PostalTradeAddress": {
                    "ram:PostcodeCode": {
                        "_text": "06000"
                    },
                    "ram:LineOne": {
                        "_text": "DEL ADRESSE LIGNE 1"
                    },
                    "ram:LineTwo": {
                        "_text": "DEL line 2"
                    },
                    "ram:CityName": {
                        "_text": "NICE"
                    },
                    "ram:CountryID": {
                        "_text": "FR"
                    }
                }
            },
            "ram:ActualDeliverySupplyChainEvent": {
                "ram:OccurrenceDateTime": {
                    "udt:DateTimeString": {
                        "_attributes": {
                            "format": "102"
                        },
                        "_text": "20200115"
                    }
                }
            },
            "ram:DespatchAdviceReferencedDocument": {
                "ram:IssuerAssignedID": {
                    "_text": "DESPADV002"
                }
            },
            "ram:ReceivingAdviceReferencedDocument": {
                "ram:IssuerAssignedID": {
                    "_text": "RECEIV-ADV002"
                }
            }
        },
        "ram:ApplicableHeaderTradeSettlement": { // Romain
            "ram:CreditorReferenceID": {
                "_text": "CREDID"
            },
            "ram:PaymentReference": {
                "_text": "F20180023BUYER"
            },
            "ram:InvoiceCurrencyCode": {
                "_text": "EUR"
            },
            "ram:PayeeTradeParty": {
                "ram:GlobalID": {
                    "_attributes": {
                        "schemeID": "0088"
                    },
                    "_text": "587451236587"
                },
                "ram:Name": {
                    "_text": "PAYEE NAME"
                },
                "ram:SpecifiedLegalOrganization": {
                    "ram:ID": {
                        "_attributes": {
                            "schemeID": "0002"
                        },
                        "_text": "123456789"
                    }
                }
            },
            "ram:SpecifiedTradeSettlementPaymentMeans": {
                "ram:TypeCode": {
                    "_text": "30"
                },
                "ram:PayerPartyDebtorFinancialAccount": {
                    "ram:IBANID": {
                        "_text": "FRDEBIT"
                    }
                },
                "ram:PayeePartyCreditorFinancialAccount": {
                    "ram:IBANID": {
                        "_text": "FR76 1254 2547 2569 8542 5874 698"
                    },
                    "ram:ProprietaryID": {
                        "_text": "LOC BANK ACCOUNT"
                    }
                }
            },
            "ram:ApplicableTradeTax": [
                {
                    "ram:CalculatedAmount": {
                        "_text": "2.20"
                    },
                    "ram:TypeCode": {
                        "_text": "VAT"
                    },
                    "ram:BasisAmount": {
                        "_text": "11.00"
                    },
                    "ram:CategoryCode": {
                        "_text": "S"
                    },
                    "ram:DueDateTypeCode": {
                        "_text": "72"
                    },
                    "ram:RateApplicablePercent": {
                        "_text": "20.00"
                    }
                },
                {
                    "ram:CalculatedAmount": {
                        "_text": "0.00"
                    },
                    "ram:TypeCode": {
                        "_text": "VAT"
                    },
                    "ram:ExemptionReason": {
                        "_text": "DEBOURS"
                    },
                    "ram:BasisAmount": {
                        "_text": "60.00"
                    },
                    "ram:CategoryCode": {
                        "_text": "E"
                    },
                    "ram:DueDateTypeCode": {
                        "_text": "72"
                    },
                    "ram:RateApplicablePercent": {
                        "_text": "0.00"
                    }
                },
                {
                    "ram:CalculatedAmount": {
                        "_text": "2.70"
                    },
                    "ram:TypeCode": {
                        "_text": "VAT"
                    },
                    "ram:BasisAmount": {
                        "_text": "27.00"
                    },
                    "ram:CategoryCode": {
                        "_text": "S"
                    },
                    "ram:DueDateTypeCode": {
                        "_text": "72"
                    },
                    "ram:RateApplicablePercent": {
                        "_text": "10.00"
                    }
                },
                {
                    "ram:CalculatedAmount": {
                        "_text": "0.00"
                    },
                    "ram:TypeCode": {
                        "_text": "VAT"
                    },
                    "ram:ExemptionReason": {
                        "_text": "LIVRAISON INTRACOMMUNAUTAIRE"
                    },
                    "ram:BasisAmount": {
                        "_text": "2.00"
                    },
                    "ram:CategoryCode": {
                        "_text": "K"
                    },
                    "ram:ExemptionReasonCode": {
                        "_text": "vatex-eu-ic"
                    },
                    "ram:DueDateTypeCode": {
                        "_text": "72"
                    },
                    "ram:RateApplicablePercent": {
                        "_text": "0.00"
                    }
                }
            ],
            "ram:BillingSpecifiedPeriod": {
                "ram:StartDateTime": {
                    "udt:DateTimeString": {
                        "_attributes": {
                            "format": "102"
                        },
                        "_text": "20191201"
                    }
                },
                "ram:EndDateTime": {
                    "udt:DateTimeString": {
                        "_attributes": {
                            "format": "102"
                        },
                        "_text": "20191231"
                    }
                }
            },
            "ram:SpecifiedTradeAllowanceCharge": [
                {
                    "ram:ChargeIndicator": {
                        "udt:Indicator": {
                            "_text": "false"
                        }
                    },
                    "ram:CalculationPercent": {
                        "_text": "5.00"
                    },
                    "ram:BasisAmount": {
                        "_text": "100.00"
                    },
                    "ram:ActualAmount": {
                        "_text": "5.00"
                    },
                    "ram:ReasonCode": {
                        "_text": "95"
                    },
                    "ram:Reason": {
                        "_text": "REMISE COMMERCIALE"
                    },
                    "ram:CategoryTradeTax": {
                        "ram:TypeCode": {
                            "_text": "VAT"
                        },
                        "ram:CategoryCode": {
                            "_text": "S"
                        },
                        "ram:RateApplicablePercent": {
                            "_text": "20.00"
                        }
                    }
                },
                {
                    "ram:ChargeIndicator": {
                        "udt:Indicator": {
                            "_text": "false"
                        }
                    },
                    "ram:CalculationPercent": {
                        "_text": "1.00"
                    },
                    "ram:BasisAmount": {
                        "_text": "100.00"
                    },
                    "ram:ActualAmount": {
                        "_text": "1.00"
                    },
                    "ram:ReasonCode": {
                        "_text": "100"
                    },
                    "ram:Reason": {
                        "_text": "REMISE COMMERCIALE"
                    },
                    "ram:CategoryTradeTax": {
                        "ram:TypeCode": {
                            "_text": "VAT"
                        },
                        "ram:CategoryCode": {
                            "_text": "S"
                        },
                        "ram:RateApplicablePercent": {
                            "_text": "20.00"
                        }
                    }
                },
                {
                    "ram:ChargeIndicator": {
                        "udt:Indicator": {
                            "_text": "false"
                        }
                    },
                    "ram:CalculationPercent": {
                        "_text": "1.00"
                    },
                    "ram:BasisAmount": {
                        "_text": "100.00"
                    },
                    "ram:ActualAmount": {
                        "_text": "1.00"
                    },
                    "ram:ReasonCode": {
                        "_text": "100"
                    },
                    "ram:Reason": {
                        "_text": "REMISE COMMERCIALE"
                    },
                    "ram:CategoryTradeTax": {
                        "ram:TypeCode": {
                            "_text": "VAT"
                        },
                        "ram:CategoryCode": {
                            "_text": "S"
                        },
                        "ram:RateApplicablePercent": {
                            "_text": "20.00"
                        }
                    }
                },
                {
                    "ram:ChargeIndicator": {
                        "udt:Indicator": {
                            "_text": "false"
                        }
                    },
                    "ram:CalculationPercent": {
                        "_text": "2.00"
                    },
                    "ram:BasisAmount": {
                        "_text": "100.00"
                    },
                    "ram:ActualAmount": {
                        "_text": "2.00"
                    },
                    "ram:Reason": {
                        "_text": "REMISE COMMERCIALE"
                    },
                    "ram:CategoryTradeTax": {
                        "ram:TypeCode": {
                            "_text": "VAT"
                        },
                        "ram:CategoryCode": {
                            "_text": "S"
                        },
                        "ram:RateApplicablePercent": {
                            "_text": "10.00"
                        }
                    }
                },
                {
                    "ram:ChargeIndicator": {
                        "udt:Indicator": {
                            "_text": "true"
                        }
                    },
                    "ram:CalculationPercent": {
                        "_text": "10.00"
                    },
                    "ram:BasisAmount": {
                        "_text": "100.00"
                    },
                    "ram:ActualAmount": {
                        "_text": "10.00"
                    },
                    "ram:ReasonCode": {
                        "_text": "FC"
                    },
                    "ram:Reason": {
                        "_text": "FRAIS DEPLACEMENT"
                    },
                    "ram:CategoryTradeTax": {
                        "ram:TypeCode": {
                            "_text": "VAT"
                        },
                        "ram:CategoryCode": {
                            "_text": "S"
                        },
                        "ram:RateApplicablePercent": {
                            "_text": "20.00"
                        }
                    }
                },
                {
                    "ram:ChargeIndicator": {
                        "udt:Indicator": {
                            "_text": "true"
                        }
                    },
                    "ram:CalculationPercent": {
                        "_text": "1.00"
                    },
                    "ram:BasisAmount": {
                        "_text": "100.00"
                    },
                    "ram:ActualAmount": {
                        "_text": "1.00"
                    },
                    "ram:ReasonCode": {
                        "_text": "ADR"
                    },
                    "ram:Reason": {
                        "_text": "FRAIS DEPLACEMENT"
                    },
                    "ram:CategoryTradeTax": {
                        "ram:TypeCode": {
                            "_text": "VAT"
                        },
                        "ram:CategoryCode": {
                            "_text": "S"
                        },
                        "ram:RateApplicablePercent": {
                            "_text": "20.00"
                        }
                    }
                },
                {
                    "ram:ChargeIndicator": {
                        "udt:Indicator": {
                            "_text": "true"
                        }
                    },
                    "ram:CalculationPercent": {
                        "_text": "2.00"
                    },
                    "ram:BasisAmount": {
                        "_text": "100.00"
                    },
                    "ram:ActualAmount": {
                        "_text": "2.00"
                    },
                    "ram:ReasonCode": {
                        "_text": "FC"
                    },
                    "ram:Reason": {
                        "_text": "FRAIS DEPLACEMENT"
                    },
                    "ram:CategoryTradeTax": {
                        "ram:TypeCode": {
                            "_text": "VAT"
                        },
                        "ram:CategoryCode": {
                            "_text": "K"
                        },
                        "ram:RateApplicablePercent": {
                            "_text": "0.00"
                        }
                    }
                },
                {
                    "ram:ChargeIndicator": {
                        "udt:Indicator": {
                            "_text": "true"
                        }
                    },
                    "ram:CalculationPercent": {
                        "_text": "1.00"
                    },
                    "ram:BasisAmount": {
                        "_text": "100.00"
                    },
                    "ram:ActualAmount": {
                        "_text": "1.00"
                    },
                    "ram:ReasonCode": {
                        "_text": "FC"
                    },
                    "ram:Reason": {
                        "_text": "FRAIS DEPLACEMENT"
                    },
                    "ram:CategoryTradeTax": {
                        "ram:TypeCode": {
                            "_text": "VAT"
                        },
                        "ram:CategoryCode": {
                            "_text": "S"
                        },
                        "ram:RateApplicablePercent": {
                            "_text": "10.00"
                        }
                    }
                }
            ],
            "ram:SpecifiedTradePaymentTerms": {
                "ram:DueDateDateTime": {
                    "udt:DateTimeString": {
                        "_attributes": {
                            "format": "102"
                        },
                        "_text": "20200215"
                    }
                },
                "ram:DirectDebitMandateID": {
                    "_text": "MANDATE PT"
                }
            },
            "ram:SpecifiedTradeSettlementHeaderMonetarySummation": {
                "ram:LineTotalAmount": {
                    "_text": "95.00"
                },
                "ram:ChargeTotalAmount": {
                    "_text": "14.00"
                },
                "ram:AllowanceTotalAmount": {
                    "_text": "9.00"
                },
                "ram:TaxBasisTotalAmount": {
                    "_text": "100.00"
                },
                "ram:TaxTotalAmount": {
                    "_attributes": {
                        "currencyID": "EUR"
                    },
                    "_text": "4.90"
                },
                "ram:GrandTotalAmount": {
                    "_text": "104.90"
                },
                "ram:TotalPrepaidAmount": {
                    "_text": "0.00"
                },
                "ram:DuePayableAmount": {
                    "_text": "104.90"
                }
            },
            "ram:InvoiceReferencedDocument": {
                "ram:IssuerAssignedID": {
                    "_text": "F20200003"
                },
                "ram:FormattedIssueDateTime": {
                    "qdt:DateTimeString": {
                        "_attributes": {
                            "format": "102"
                        },
                        "_text": "20200101"
                    }
                }
            },
            "ram:ReceivableSpecifiedTradeAccountingAccount": {
                "ram:ID": {
                    "_text": "BUYER ACCOUNT REF"
                }
            }
        }
    }
}
 */
